// @flow

import React from "react";

import Section from "../../components/Section";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";

import { BANK_CODE, BANK_NAME, GENDER, EMAIL, PHONE_NUMBER, BANK_ADVISOR } from "./formFields";

import { mapGender } from "./mappers";

type PersonalInfoProps = {
  initialValues: {
    email: string,
    first_name: string,
    gender: string,
    last_name: string,
    phone_number: string,
    position: string,
    bankCode: string
  },
  numbered?: boolean
};

const PersonalInfo = ({ initialValues, numbered }: PersonalInfoProps) => (
  <Section title="Informationen zum Ansprechpartner" reducedMargin numbered={numbered}>
    <EditableForm initialValues={initialValues} isLocked>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: BANK_CODE,
            caption: () => "BLZ"
          }}
        />

        <EditableField
          fieldControlProps={{
            name: BANK_NAME,
            caption: () => "Bank"
          }}
        />
        <div />
      </FormRow>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: GENDER,
            caption: () => "Anrede"
          }}
          displayValue={mapGender}
        />
        <EditableField
          fieldControlProps={{
            name: BANK_ADVISOR,
            caption: () => "Einsteller"
          }}
        />
        <div />
      </FormRow>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: EMAIL,
            caption: () => "E-Mail"
          }}
        />
        <EditableField
          fieldControlProps={{
            name: PHONE_NUMBER,
            caption: () => "Telefon"
          }}
        />
        <div />
      </FormRow>
    </EditableForm>
  </Section>
);

PersonalInfo.defaultProps = {
  numbered: true
};

export default PersonalInfo;
